<template>
    <x-page title="Kategori Group">
        <template #header-actions>
            <x-create-button url="/admin/group-categories/create" 
                :disabled="isLoading"
                v-if="can('createGroupCategories')" />
        </template>

        <x-filter-box :onFilter="handleFilter"
            :onReset="resetFilter">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Label">
                        <input class="form-control"
                            type="text"
                            v-model="filters.search"
                            @keyup.enter="() => handleFilter()"
                            placeholder="Masukkan label kategori" />
                    </x-form-group>
                </div>
            </div>
        </x-filter-box>

        <x-table :headers="[
            '#',
            'Label',
            '',
        ]" :is-loading="isLoading">
            <tr v-for="(resource, index) in resources" :key="index">
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    <router-link :to="`/admin/group-categories/${resource.id}`" 
                        title="Klik untuk lihat detail">
                        {{ resource.label }}
                    </router-link>
                    <div>
                        <x-sms-blast-label v-if="resource.sms_birthday_blast" :inline="true" />
                        
                        <!-- Enter trigger label -->
                        <x-label-group-trigger 
                            v-if="resource.enter_trigger" 
                            color="success"
                            label="Trigger masuk"
                            title="Trigger masuk aktif"
                        />

                        <!-- Exit trigger label -->
                        <x-label-group-trigger 
                            v-if="resource.exit_trigger" 
                            color="danger"
                            label="Trigger keluar"
                            title="Trigger keluar aktif"
                        />
                    </div>
                </td>
                <td>
                    <x-quick-edit-button :url="`/admin/group-categories/${resource.id}/edit`"
                        :disabled="isLoading" v-if="can('updateGroupCategories')" />
                    <x-quick-delete-button @click="deleteResource(resource)"
                        :disabled="isLoading" v-if="can('deleteGroupCategories')" />
                </td>
            </tr>
        </x-table>

        <x-pagination v-if="shouldRenderPagination" :pagination="meta" />
    </x-page>
</template>

<script>
import XAjaxDropdown from '../../components/XAjaxDropdown.vue'
import XCreateButton from '../../components/XCreateButton.vue'
import XQuickDeleteButton from '../../components/XQuickDeleteButton.vue'
import XQuickEditButton from '../../components/XQuickEditButton.vue'
import XFilterBox from '../../components/XFilterBox.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import XPage from '../../components/XPage.vue'
import XTable from '../../components/XTable.vue'
import { deletePrompt, handleGeneralXhrError } from '../../helpers'
import FilterableMixin from '../../mixins/FilterableMixin'
import PaginationMixin from '../../mixins/PaginationMixin'
import PermissionMixin from '../../mixins/PermissionMixin'
import XSmsBlastLabel from '../../components/XSmsBlastLabel.vue'
import XLabelGroupTrigger from '../../components/XLabelGroupTrigger.vue'

const defaultFilters = {
    search: null,
    status: null,
}

export default {
    beforeRouteUpdate(to, from, next) {
		this.fetchResources(to)
		next()
	},
    components: {
        XCreateButton,
        XTable,
        XQuickEditButton,
        XQuickDeleteButton,
        XPage,
        XFormGroup,
        XFilterBox,
        XAjaxDropdown,
        XSmsBlastLabel,
        XLabelGroupTrigger,
    },
    created() {
        this.preselectFilters(defaultFilters)
        this.handleFilter().catch(() => {
            this.fetchResources()
        })
    },
    data() {
        return {
            filters: { ...defaultFilters },
            isLoading: false,
            resources: [],
        }
    },
    methods: {
        deleteResource(resource) {
            deletePrompt({
                name: resource.label,
                onConfirm: () => {
                    this.isLoading = true
                    const request = axios.delete(`/api/group-categories/${resource.id}`)
                        .then(() => {
                            this.$notify({
                                type: 'success',
                                title: `Berhasil`,
                                text: `${resource.label} dihapus!`,
                            })
                            this.fetchResources()
                        })
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false
                    })
                },
            })
        },
        fetchResources(route = this.$route) {
            this.isLoading = true
            const request = axios.get('/api/group-categories', {
                params: {
                    ...route.query,
                    append: ['enter_trigger', 'exit_trigger'],
                    without_global_scopes: 1,
                }
            })
            .then(response => {
                this.resources = response.data.data
                this.setMeta(response)
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleFilter() {
            return this.$router.push({
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    page: 1,
                }),
            })
        },
        resetFilter() {
            this.filters = { ...defaultFilters }
            this.handleFilter()
        },
    },
    mixins: [
        FilterableMixin,
        PaginationMixin,
        PermissionMixin,
    ],
}
</script>